import type { Locale } from '../../i18n/index';
import type { IpContent, StartContent } from './types';
import { startRu } from './start.ru';
import { startUz } from './start.uz';
import { ipRu } from './ip.ru';
import { ipUz } from './ip.uz';

// ru + uz only — the /start and /ip conversion landings have no Kazakh copy, so
// the kk locale falls back to ru (its deployment's default).
const START = { ru: startRu, uz: startUz } as const;
const IP = { ru: ipRu, uz: ipUz } as const;

export function startContent(locale: Locale): StartContent {
  return START[locale as keyof typeof START] ?? START.ru;
}

export function ipContent(locale: Locale): IpContent {
  return IP[locale as keyof typeof IP] ?? IP.ru;
}
